import { NavItemSchema } from '@shared/interfaces/nav/nav-item-schema';

export const veeNavItems: NavItemSchema[] = [
  {
    title: 'vee.overview.title',
    routeTemplate: ['/vee', '{id}'],
  },
  {
    title: 'vee.meteringpoints.title',
    routeTemplate: ['/vee', '{id}', 'meteringpoints'],
  }
]
